import React from 'react';
import PropTypes from 'prop-types';

import { questionShape, answerShape } from '../../../shapes/entities';
import AnswerList from './answer_list';
import AnswerTable from './answer_table';
import AnswerDropdown from './answer_dropdown'; // eslint-disable-line import/no-named-as-default

import answerModes from '../../../../../shared/constants/answer_modes';

const toggle = (values, x) =>
  values.indexOf(x) >= 0 ? values.filter(e => e !== x) : values.concat([x]);

const Answers = ({
  question,
  answers,
  selected,
  isMultipleChoice,
  isReview,
  onUpdateAnswer
}) => {
  const props = {
    question,
    answers,
    selected,
    isReview,
    isMultipleChoice,
    onToggleAnswer: ({ id }) =>
      onUpdateAnswer(isMultipleChoice ? toggle(selected, id) : [id])
  };
  const { answer_mode: answerMode } = question.attributes;
  if (answerMode === answerModes.table.id) {
    return <AnswerTable {...props} />;
  }
  if (answerMode === answerModes.dropdown.id) {
    return <AnswerDropdown {...props} />;
  }
  return <AnswerList {...props} />;
};

Answers.propTypes = {
  question: questionShape.isRequired,
  answers: PropTypes.arrayOf(answerShape).isRequired,
  selected: PropTypes.arrayOf(PropTypes.string).isRequired,
  onUpdateAnswer: PropTypes.func.isRequired,
  isMultipleChoice: PropTypes.bool.isRequired,
  isReview: PropTypes.bool.isRequired
};

export default Answers;
